import { isValidElement, useCallback } from 'react'
import { getDeepestString } from 'utils/getReactNodeLength'
import { CIMSSelectProps, DefaultOptionType } from '../types'

type UseFilterOptionFn = (
  inputValue: string,
  option?: DefaultOptionType
) => boolean

/**
 * a customized filterOption callback for the CIMSSelect component
 *
 * @param options {@link CIMSSelectProps}
 */
export function useFilterOption(options?: Pick<CIMSSelectProps, '__debug'>) {
  return useCallback<UseFilterOptionFn>(
    (input, option) => {
      const { value, label } = option ?? {}
      const tooltip = isValidElement(label)
        ? label.props?.title?.toString()
        : getDeepestString(label)
      const searches = [getDeepestString(label), `${value}`, tooltip]
      const found = searches.some((i) =>
        i?.toLowerCase()?.includes(input.toLowerCase())
      )
      if (options?.__debug)
        console.log('filterOption', {
          found,
          input,
          searches,
          ...option,
        })
      return found
    },
    [options]
  )
}
